// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"9a91216d","186":"befaa8cf","344":"9b30e7a3","372":"2cb8c32a","738":"715e1b49","787":"b9d9f9e2","841":"e8381491","851":"8786824f","856":"9d44bf7f"}[chunkId] + ".chunk.js";
};